import { tw } from "@careinfo/tailwind";
import useGetHook from "../../../customHooks/useGetHook";
import APIS from "../../../constant/Endpoint";
import { forwardRef } from "react";
import { getKey } from "../../../helpers/sessionKey";

interface Props {
  clientDetails?: any;
  data?: any;
  clientName?: any;
}
const PartyWiseSummary = forwardRef<HTMLDivElement, Props>(
  ({ data, clientDetails, clientName }, ref) => {
    if (!data) return <p>Loading...</p>;

    const debtors = data?.sundry_debtors || [];
    const creditors = data?.sundry_creaditors || [];

    const totalDebtors = debtors.reduce(
      (sum: number, item: any) => sum + Number(item.outstanding_balance),
      0
    );

    const totalCreditors = creditors.reduce(
      (sum: number, item: any) => sum + Number(item.outstanding_balance),
      0
    );

    return (
      <div ref={ref} className={tw`p-4`}>
        <div className="pdf-header hidden text-center mb-3">
          <h1 className={tw`text-[40px] font-bold text-primary`}>
            {clientName?.business_name}
          </h1>

          <p className={tw`text-lg font-semibold`}>{clientDetails?.address}</p>

          <p className={tw`text-blue-600 font-lg text-md`}>
            Debtors/Creditors Report as on{" "}
            {new Date().toISOString().split("T")[0]}
          </p>
        </div>

        {/* <div className={tw`border-t border-gray-400 mb-2`} /> */}
        <table className={tw`w-full border rounded-md`}>
          <thead>
            <tr className={tw`bg-primary text-white`}>
              <th className={tw`p-2 text-left`}>S/N</th>
              <th className={tw`p-2 text-left`}>A/c Code</th>
              <th className={tw`p-2 text-left`}>Account Description</th>
              <th className={tw`p-2 text-right`}>Outstanding Amount</th>
            </tr>
          </thead>

          <tbody>
            <tr className={tw`font-semibold`}>
              <td colSpan={4} className={tw`p-2`}>
                Sundry Creditors
              </td>
            </tr>

            {creditors.map((item: any, index: number) => (
              <tr key={index}>
                <td className={tw`p-2`}>{index + 1}</td>
                <td className={tw`p-2`}>{item.code}</td>
                <td className={tw`p-2 text-right`}>{item.full_name}</td>
                <td className={tw`p-2 text-right`}>
                  {Number(item.outstanding_balance).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                  })}
                </td>
              </tr>
            ))}

            <tr className={tw`font-semibold bg-gray-100`}>
              <td colSpan={3} className={tw`p-2 text-center`}>
                Sundry Creditors Sub Total
              </td>
              <td className={tw`p-2 text-right`}>
                {totalCreditors.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </td>
            </tr>

            <tr className={tw`font-semibold`}>
              <td colSpan={4} className={tw`p-2`}>
                Sundry Debtors
              </td>
            </tr>

            {debtors.map((item: any, index: number) => (
              <tr key={index}>
                <td className={tw`p-2`}>{index + 1}</td>
                <td className={tw`p-2`}>{item.code}</td>
                <td className={tw`p-2`}>{item.full_name}</td>
                <td className={tw`p-2 text-right`}>
                  {Number(item.outstanding_balance).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                  })}
                </td>
              </tr>
            ))}

            <tr className={tw`font-semibold bg-gray-100`}>
              <td colSpan={3} className={tw`p-2 text-center`}>
                Sundry Debtors Sub Total
              </td>
              <td className={tw`p-2 text-right`}>
                {totalDebtors.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
);

export default PartyWiseSummary;

